import React from 'react';
import { Divider, H3 } from '@blueprintjs/core';

import { AverageOfColorsData } from '../../types';

import { buildPpgChart } from '../../../../utils/buildLineCharts';

interface AverageOfColorsProps {
  data: AverageOfColorsData;
}

const AverageOfColors = ({ data }: AverageOfColorsProps) => {
  return (
    <>
      <H3>Resultado do Algoritmo:</H3>
      <>
        {data.red.length > 0 &&
          buildPpgChart(data.red, 'Red Color', 'BE4228', data.duration)}
        {data.blue.length > 0 &&
          buildPpgChart(data.blue, 'Blue Color', '253AD8', data.duration)}
        {data.green.length > 0 &&
          buildPpgChart(data.green, 'Green Color', '18870B', data.duration)}
        <Divider />
        {data.hue.length > 0 &&
          buildPpgChart(data.hue, 'HUE', 'BE4228', data.duration)}
        {data.saturation.length > 0 &&
          buildPpgChart(data.saturation, 'Saturation', '253AD8', data.duration)}
        {data.value.length > 0 &&
          buildPpgChart(data.value, 'Value', '18870B', data.duration)}
      </>
    </>
  );
};

export default AverageOfColors;
